export default __webpack_public_path__ + "b997733b1f6d3194345b1dca250f4163.svg";